import React from "react";
import { connect } from "react-redux";
import Styled from "./TableList.styles";
import MeterRow from "./_components/MeterRow";
import l10n from "../../../../localization";
import { isBrowser } from "react-device-detect";
import MobileMeterRows from "./_components/MobileMeterRows/MobileMeterRows";

const TableList = ({ meters, meterSiteCode, meterCode }) => {
  let filteredMeters = meters.result;

  if (meterSiteCode !== "all") {
    filteredMeters = meters.result.filter(
      (meter) => meter.meterSiteCode === meterSiteCode
    );
  }

  const renderUserMeters = (meter) => {
    if (meterCode !== "all") {
      return [
        ...meter.userMeters.filter(
          (userMeter) => userMeter.meterCode === meterCode
        ),
      ];
    } else {
      return [...meter.userMeters];
    }
  };

  function renderTable(meter, userMeter) {
    if (isBrowser) {
      return (
        <Styled.Table>
          <thead>
            <tr border="1">
              <th>{l10n.reports.date}</th>
              <th>{l10n.reports.meterCode}</th>
              <th>{l10n.reports.reading}</th>
              <th>{l10n.reports.consumption}</th>
              <th>{l10n.reports.deducedConsumption}</th>
              <th>{l10n.reports.addedConsumption}</th>
              <th>{l10n.reports.accountedConsumption}</th>
              <th>{l10n.reports.status}</th>
            </tr>
          </thead>
          <tbody>
            <MeterRow
              meterSiteCode={meter.meterSiteCode}
              meterCode={userMeter.meterCode}
              meters={meters}
            />
          </tbody>
        </Styled.Table>
      );
    } else {
      return (
        <Styled.CardMobileTable>
          <MobileMeterRows
            meterSiteCode={meter.meterSiteCode}
            meterCode={userMeter.meterCode}
            meters={meters}
          />
        </Styled.CardMobileTable>
      );
    }
  }

  return (
    <>
      {filteredMeters.map((meter, meterIndex) => (
        <div key={`${meter.meterSiteCode}_${meterIndex}`}>
          {renderUserMeters(meter).map((userMeter, userMeterIndex) => (
            <Styled.Card key={`${userMeter.meterCode}_${userMeterIndex}`}>
              <Styled.HeaderWrapper>
                <Styled.Header>
                  <Styled.HeaderRow>
                    <Styled.HeaderTitle>
                      {l10n.reports.site_address}:
                    </Styled.HeaderTitle>
                    <Styled.HeaderContent>
                      {meter.siteAddress}
                    </Styled.HeaderContent>
                  </Styled.HeaderRow>
                  <Styled.HeaderRow>
                    <Styled.HeaderTitle>
                      {l10n.reports.meter}:{" "}
                    </Styled.HeaderTitle>
                    <Styled.HeaderContent>
                      {userMeter.meterCode}
                    </Styled.HeaderContent>
                  </Styled.HeaderRow>
                </Styled.Header>
                <Styled.MeterData>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.mainMeterType}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {meter.meterType || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterType}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.type || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterManufacturer}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.manufacturer || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterDiameter}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.diameter || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterNValve}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.nValve
                        ? l10n.reports.meterYes
                        : l10n.reports.meterNo}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterReadingType}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.readingType || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem />
                </Styled.MeterData>
              </Styled.HeaderWrapper>

              {renderTable(meter, userMeter)}
            </Styled.Card>
          ))}
        </div>
      ))}
    </>
  );
};

export default connect(({ meters }) => ({ meters }), null)(TableList);
